import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Listas } from 'src/app/models/generic/Listas';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { Producto } from '../../models/generic/Producto';
import { ProductosService } from '../../services/productos.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { Constantes } from '../../models/modules/Constantes';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { GestionAfiliadoService } from '../../services/gestionafiliado.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { GestionAfiliado_Parametro } from '../../models/generic/GestionAfiliado_Parametro';
import { GestionAfiliado_Detalle } from '../../models/generic/GestionAfiliado_Detalle';
import { Estados } from 'src/app/models/generic/Estados';
import { ProductosEdades } from '../../models/generic/ProductosEdades';
import { AliadoDatosAdicionales } from 'src/app/models/generic/AliadoDatosAdicionales';

@Component({
  selector: 'gestion-afiliados-estado',
  templateUrl: './gestion-afiliados-estado.component.html',
  styleUrls: ['./gestion-afiliados-estado.component.scss']
})
export class GestionAfiliadosEstadoComponent implements OnInit{
  
  nombreAliado: string = '';
  idAplicacion: number = 0;
  idAliado: number = 0;
  idProducto: number = 0;
  tituloEstado: string = '';
  tituloBoton: string = '';
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  parametrosPrincipal: GestionAfiliado_Parametro;
  gestionAfiliado_Detalle: GestionAfiliado_Detalle;
  listaMotivos: Listas[] = [];
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  textoMostrar: string = '';
  listaPlazoProducto: Listas[];
  listaEstados: Estados[] = [];
  listaProductosEdades: ProductosEdades[];
  listaProductosEdadesFiltrada: ProductosEdades[];
  registrarEstado: boolean = false;
  estadoDependienteFecha: boolean = false;
  calculoPrecioEdad: boolean = false;
  permitirActualizarEstado: boolean = true;
  permitirIngresoPrecio: boolean = false;
  ListaProductos: Producto[] = [];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public gestionAfiliadoService: GestionAfiliadoService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public productosService: ProductosService) {}

  ngOnInit() {
    this.IniciarFormulario(true);
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
    this.nombreAliado = this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].aliado;
    this.idAplicacion = this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idAplicacion;
    this.idAliado = this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idAliado;
    this.idProducto = this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProducto;
    
    console.log('CargarDatosEstado', this.parametrosPrincipal.gestionAfiliado_Seleccionado[0])

    this.IniciarFormulario(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].activo);

    this.form.get('nroDocumento').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nroDocumento);
    this.form.get('nombresApellidos').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nombresApellidos);
    this.form.get('fechaAfiliacion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].fechaAfiliacion);
    this.form.get('activoRegistro').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].activo);
    this.form.get('activo').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].activo);
    this.form.get('idProducto').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProducto);
    this.form.get('idProductoInicial').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProducto);
    this.form.get('productoInicial').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].producto);
    this.form.get('estado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estado);
    this.form.get('estadoColor').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoColor);
    this.form.get('estadoDescripcion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoDescripcion);
    this.form.get('estadoDescripcionColor').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoDescripcionColor);
    this.form.get('edad').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].edad);
    this.form.get('idEstado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idEstado);
    this.form.get('idProductoEdad').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProductoEdad);
    this.form.get('nroPoliza').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nroPoliza);
    this.form.get('idProductoUnico').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProductoUnico);
    
    this.form.get('precioNuevo').setValue(0);
    
    this.mostrarCargando = true;
    this.ConsultarListasConfiguracion();
    this.ConsultarListaProductosEdades();
    this.ConsultarListaEstados();
    this.ConsultarDatosAdicionalesAliado();
    this.ConsultarGestionAfiliadoDetalle();
  }

  IniciarFormulario(activo: boolean) {
    if (activo === false) {
      this.form = this.fb.group({
        nroDocumento: [''],
        nombresApellidos: [''],
        fechaAfiliacion: [new Date()],
        activoRegistro: [false],
        activo: [false],
        motivo: ['', Validators.required],
        idProducto: ['', Validators.required],
        idProductoPlazo: ['', Validators.required],
        descripcionMotivo: ['', [Validators.maxLength(250)]],
        idProductoInicial: [0],
        productoInicial: [''],
        movil: ['', [Validators.required, Validators.maxLength(20)]],
        email: ['', [Validators.required, Validators.maxLength(40), Validators.email]],
        estado: [''],
        estadoColor: [''],
        estadoDescripcion: [''],
        estadoDescripcionColor: [''],
        edad: [0],
        idEstado: [0],
        idProductoEdad: [0],
        idProductoEdadDescripcion: [''],
        nroPoliza: [''],
        precioNuevo: [0],
        idProductoUnico: [0]
      });
    } else {
      this.form = this.fb.group({
        nroDocumento: [''],
        nombresApellidos: [''],
        fechaAfiliacion: [new Date()],
        activoRegistro: [false],
        activo: [false],
        motivo: ['', Validators.required],
        idProducto: [''],
        idProductoPlazo: [''],
        descripcionMotivo: [''],
        idProductoInicial: [0],
        productoInicial: [''],
        movil: ['', [Validators.required, Validators.maxLength(20)]],
        email: ['', [Validators.required, Validators.maxLength(40), Validators.email]],
        estado: [''],
        estadoColor: [''],
        estadoDescripcion: [''],
        estadoDescripcionColor: [''],
        edad: [0],
        idEstado: [0],
        idProductoEdad: [0],
        idProductoEdadDescripcion: [''],
        nroPoliza: ['', [Validators.maxLength(100)]],
        precioNuevo: [0],
        idProductoUnico: [0]
      });
    }

    this.form.get('idProductoEdadDescripcion').disable();
    
    this.form.get('idProducto').valueChanges.subscribe((valorNuevo) => {
      this.VerificarCambioPrecioEstado(valorNuevo);
      this.CargarListaPlazosProducto(valorNuevo);
      this.CargarListaProductosEdad(valorNuevo);
    });
    this.form.get('idEstado').valueChanges.subscribe((valorNuevo) => {
      this.AsignarActivoInactivo(valorNuevo);
    });
  }
  EstablecerDatosAdicionalesRequeridos() {
    if (this.registrarEstado) {
      let validatorsEstado = [];
      validatorsEstado.push(Validators.required);
      validatorsEstado.push(Validators.min(1));
      this.form.get('idEstado').setValidators(validatorsEstado);
      this.form.get('idEstado').updateValueAndValidity();

      let validatorsLimpiar = [];
      this.form.get('motivo').setValidators(validatorsLimpiar);
      this.form.get('motivo').updateValueAndValidity();

      this.form.get('idProducto').setValidators(validatorsLimpiar);
      this.form.get('idProducto').updateValueAndValidity();

      this.form.get('idProductoPlazo').setValidators(validatorsLimpiar);
      this.form.get('idProductoPlazo').updateValueAndValidity();

      this.form.get('idProductoPlazo').setValidators(validatorsLimpiar);
      this.form.get('idProductoPlazo').updateValueAndValidity();
    }

    if (this.permitirIngresoPrecio) {
      let validatorsPrecio = [];
      validatorsPrecio.push(Validators.required);
      validatorsPrecio.push(Validators.min(1));
      this.form.get('precioNuevo').setValidators(validatorsPrecio);
      this.form.get('precioNuevo').updateValueAndValidity();
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('GestionAfiliadosComponent', JSON.stringify(this.parametrosPrincipal));
  }
  ConsultarGestionAfiliadoDetalle() {
    this.gestionAfiliadoService.ConsultarDetalle(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0])
                .subscribe((resp: GestionAfiliado_Detalle[]) =>{
                  this.gestionAfiliado_Detalle = resp[0];

                  this.form.get('idProductoPlazo').setValue(this.gestionAfiliado_Detalle.idProductoPlazo);
                  this.form.get('movil').setValue(this.gestionAfiliado_Detalle.movil);
                  this.form.get('email').setValue(this.gestionAfiliado_Detalle.email);
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarListasConfiguracion() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.idAplicacion);
    parametrosConsulta.get('idAliado').setValue(this.idAliado);
    this.gestionAfiliadoService.ConsultarListas(parametrosConsulta.value)
                .subscribe((resp: Listas[]) =>{
                  this.gestionAfiliadoService.ListasConfiguracion = resp;
                  this.CargarProductos();
                  this.CargarProductosCompletos();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarListaProductosEdades() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.idAplicacion);
    parametrosConsulta.get('idAliado').setValue(this.idAliado);
    this.gestionAfiliadoService.ConsultarProductosEdades(parametrosConsulta.value)
                .subscribe((resp: ProductosEdades[]) =>{
                  this.listaProductosEdades = resp;
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarListaEstados() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.idAplicacion);
    parametrosConsulta.get('idAliado').setValue(this.idAliado);
    this.gestionAfiliadoService.ConsultarEstados(parametrosConsulta.value)
                .subscribe((resp: Estados[]) =>{
                  if (resp.filter(x => x.id === this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idEstado).length > 0) {
                    let idSiguiente: number = resp.filter(x => x.id === this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idEstado)[0].idSiguiente;
                    let idSiguienteVarios: string = resp.filter(x => x.id === this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idEstado)[0].idSiguienteVarios;
                    
                    if (this.utilitariosService.VerificarContieneDatos(idSiguiente)) {
                      this.listaEstados = resp.filter(x => x.id === idSiguiente);
                    } else if (this.utilitariosService.VerificarContieneDatos(idSiguienteVarios)) {
                      let listaEstadosHabilitados: Estados[] = [];
                      let itemsSeparados = idSiguienteVarios.split(',');

                      for (let index = 0; index < itemsSeparados.length; index++) {
                        let item = itemsSeparados[index];
                        let estadosFiltrado = resp.filter(x => x.id === +item);
                        for (let index = 0; index < estadosFiltrado.length; index++) {
                          listaEstadosHabilitados.push(estadosFiltrado[index]);
                        }
                      }

                      this.listaEstados = listaEstadosHabilitados;
                    }

                    if (this.listaEstados.length > 0) {
                      this.form.get('idEstado').setValue(this.listaEstados[0].id);
                      this.AsignarActivoInactivo(this.listaEstados[0].id);
                    } else {
                      if (this.registrarEstado) {
                        this.permitirActualizarEstado = false;
                      }
                    }
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarDatosAdicionalesAliado() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
      ,idProducto: [0]
      ,tipoNotificacion: ['E']
    });
    parametrosConsulta.get('idAplicacion').setValue(this.idAplicacion);
    parametrosConsulta.get('idAliado').setValue(this.idAliado);
    
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.idProducto)) {
      parametrosConsulta.get('idProducto').setValue(this.idProducto);
    }
    
    this.productosService.ConsultarDatosAdicionalesAliado(parametrosConsulta.value)
                .subscribe((resp: AliadoDatosAdicionales) =>{
                  // this.registrarEstado = resp.registrarEstado;
                  this.calculoPrecioEdad = resp.calculoPrecioEdad;
                  
                  this.EstablecerDatosAdicionalesRequeridos();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ObtenerListaConfiguracion() {
    let listasConfiguracion: Listas[] = [];

    if (this.registrarEstado) {
      this.tituloEstado = 'Actualización estado del afiliado';
      this.tituloBoton = 'Actualizar estado';
      this.textoMostrar = '¿Deseas proceder actualizar el estado del afiliado?'
    } else {
      if (this.form.get('activoRegistro').value) {
        this.tituloEstado = 'Inactivación del afiliado';
        this.tituloBoton = 'Inactivar afiliado';
        this.textoMostrar = '¿Deseas proceder a inactivar el afiliado?'
      } else {
        this.tituloEstado = 'Reactivación del afiliado';
        this.tituloBoton = 'Reactivar afiliado';
        this.textoMostrar = '¿Deseas proceder a reactivar el afiliado?'
      }
    }

    if (this.form.get('activoRegistro').value) {
      for (let index = 0; index < this.gestionAfiliadoService.ListasConfiguracion.length; index++) {
        if (this.gestionAfiliadoService.ListasConfiguracion[index].lista === 'MOTIVOSBAJA') {
          listasConfiguracion.push(this.gestionAfiliadoService.ListasConfiguracion[index]);
        }
      }
    } else {
      for (let index = 0; index < this.gestionAfiliadoService.ListasConfiguracion.length; index++) {
        if (this.gestionAfiliadoService.ListasConfiguracion[index].lista === 'MOTIVOSALTA') {
          listasConfiguracion.push(this.gestionAfiliadoService.ListasConfiguracion[index]);
        }
      }
    }

    this.listaMotivos = listasConfiguracion;
  }
  ejecutarAccion() {
    if (this.form.valid) {
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.parametrosPrincipal.tituloEstado = this.tituloEstado;
      this.mostrarCargando = true;

      let parametrosAccion = this.fb.group({
        id: [0],
        idProducto: [0],
        idProductoNuevo: [0],
        idProductoPlazo: [0],
        idProductoPlazoNuevo: [0],
        idAplicacion: [0],
        idAliado: [0],
        activo: [false],
        motivo: [''],
        descripcionMotivo: [''],
        email: [''],
        movil: [''],
        edad: [0],
        idProductoEdad: [0],
        idEstado: [0],
        nroPoliza: [''],
        precioNuevo: [0],
        idProductoUnico: [0]
      });

      parametrosAccion.get('id').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].id);
      parametrosAccion.get('idProducto').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProducto);
      parametrosAccion.get('idProductoUnico').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProductoUnico);
      
      if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('idProducto').value)) {
        parametrosAccion.get('idProductoNuevo').setValue(this.form.get('idProducto').value);
      }
      if (this.utilitariosService.VerificarContieneDatosNumerico(this.gestionAfiliado_Detalle.idProductoPlazo)) {
        parametrosAccion.get('idProductoPlazo').setValue(this.gestionAfiliado_Detalle.idProductoPlazo);
      }
      if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('idProductoPlazo').value)) {
        parametrosAccion.get('idProductoPlazoNuevo').setValue(this.form.get('idProductoPlazo').value);
      }
      if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('edad').value)) {
        parametrosAccion.get('edad').setValue(this.form.get('edad').value);
      }
      if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('idProductoEdad').value)) {
        parametrosAccion.get('idProductoEdad').setValue(this.form.get('idProductoEdad').value);
      }
      if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('idEstado').value)) {
        parametrosAccion.get('idEstado').setValue(this.form.get('idEstado').value);
      }

      if (this.TieneEstadoRegistro(this.form.get('idEstado').value)) {
        parametrosAccion.get('activo').setValue(this.ObtenerEstadoRegistro(this.form.get('idEstado').value));
      } else {
        parametrosAccion.get('activo').setValue(!this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].activo);
      }

      parametrosAccion.get('idAplicacion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idAplicacion);
      parametrosAccion.get('idAliado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idAliado);
      parametrosAccion.get('motivo').setValue(this.form.get('motivo').value);
      parametrosAccion.get('descripcionMotivo').setValue(this.form.get('descripcionMotivo').value);
      parametrosAccion.get('email').setValue(this.form.get('email').value);
      parametrosAccion.get('movil').setValue(this.form.get('movil').value);
      parametrosAccion.get('nroPoliza').setValue(this.form.get('nroPoliza').value);
      parametrosAccion.get('precioNuevo').setValue(this.form.get('precioNuevo').value);

      this.gestionAfiliadoService.ActualizarEstado(parametrosAccion.value)
                .subscribe((resp: RespuestaGenerica) =>{
                  this.mostrarCargando = false;
                  if (resp.procesoExitoso == false) {
                    this.utilitariosService.MensajeToast(resp.mensaje);
                  } else {
                    this.gestionAfiliado_Detalle.email = this.form.get('email').value;
                    this.gestionAfiliado_Detalle.movil = this.form.get('movil').value;
                    this.menuService.CambiarComponenteActivo('GestionAfiliadosConfirmacionComponent', JSON.stringify(this.parametrosPrincipal));
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  CargarProductos() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.idAplicacion);
    parametrosConsulta.get('idAliado').setValue(this.idAliado);
    
    this.gestionAfiliadoService.ConsultarProductos(parametrosConsulta.value).subscribe((resp: Producto[]) => {
      this.ListaProductos = resp;
      this.CargarListaPlazosProducto(this.form.get('idProducto').value);
      this.CargarListaProductosEdad(this.form.get('idProducto').value);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },(error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  CargarProductosCompletos() {
    let parametrosConsulta = this.fb.group({
      idAplicacion: [0]
      ,idAliado: [0]
    });
    parametrosConsulta.get('idAplicacion').setValue(this.idAplicacion);
    parametrosConsulta.get('idAliado').setValue(this.idAliado);
    this.gestionAfiliadoService.ConsultarProductosCompletos(parametrosConsulta.value).subscribe((resp: Producto[]) => {
      this.productosService.ListaProductosCompletos = resp;

      if (this.productosService.ListaProductosCompletos.filter(x => x.id === this.form.get('idProducto').value).length > 0) {
        this.registrarEstado = this.productosService.ListaProductosCompletos.filter(x => x.id === this.form.get('idProducto').value)[0].registrarEstado;
        this.estadoDependienteFecha = this.productosService.ListaProductosCompletos.filter(x => x.id === this.form.get('idProducto').value)[0].estadoDependienteFecha;
      }

      this.ObtenerListaConfiguracion();
      this.VerificarCambioPrecioEstado(this.form.get('idProducto').value);
      this.EstablecerDatosAdicionalesRequeridos();

      if (this.permitirIngresoPrecio) {
        if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].precioRegistro)) {
          this.form.get('precioNuevo').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].precioRegistro);
        }
      }
    },(error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  VerificarCambioPrecioEstado(idProducto: number) {
    if (this.productosService.ListaProductosCompletos.filter(x => x.id === idProducto && x.cambiarPrecioEstado).length > 0) {
      this.permitirIngresoPrecio = true;
    } else {
      this.permitirIngresoPrecio = false;
    }
  }
  CargarListaPlazosProducto(idProducto: number) {
    let listaPlazosProducto: Listas[] = [];
    let listaFiltrada = this.gestionAfiliadoService.ListasConfiguracion.filter(x => x.lista === Constantes.LISTAS_PRODUCTOSPLAZOS());

    for (let index = 0; index < listaFiltrada.length; index++) {
      if (listaFiltrada[index].dependienciaId === idProducto) {
        listaPlazosProducto.push(listaFiltrada[index]);
      }
    }
    this.listaPlazoProducto = listaPlazosProducto;
  }
  CargarListaProductosEdad(idProducto: number) {
    if (this.utilitariosService.VerificarContieneDatos(this.listaProductosEdades)) {
      this.listaProductosEdadesFiltrada = this.listaProductosEdades.filter(x => x.producto === idProducto);
      this.AsignarProductoEdad(this.form.get('edad').value);
    }
  }
  AsignarProductoEdad(edad: number) {
    this.form.get('idProductoEdad').setValue(0);
    this.form.get('idProductoEdadDescripcion').setValue('');
    if (this.utilitariosService.VerificarContieneDatos(this.listaProductosEdadesFiltrada)) {
      if (this.listaProductosEdadesFiltrada.filter(x => x.inicio <= edad && x.fin >= edad).length > 0) {
        this.form.get('idProductoEdad').setValue(this.listaProductosEdadesFiltrada.filter(x => x.inicio <= edad && x.fin >= edad)[0].id);
        this.form.get('idProductoEdadDescripcion').setValue(this.listaProductosEdadesFiltrada.filter(x => x.inicio <= edad && x.fin >= edad)[0].descripcion);
      }
    }
  }
  AsignarActivoInactivo(idEstado: number) {
    if (this.listaEstados) {
      if (this.listaEstados.filter(x => x.id === idEstado).length > 0) {
        this.form.get('activo').setValue(this.listaEstados.filter(x => x.id === idEstado)[0].activo);
      }
    }
  }
  TieneEstadoRegistro(idEstado): boolean {
    if (this.listaEstados) {
      if (this.listaEstados.filter(x => x.id === idEstado).length > 0) {
        return true;
      }
    }
    return false;
  }
  ObtenerEstadoRegistro(idEstado): boolean {
    return this.listaEstados.filter(x => x.id === idEstado)[0].activo;
  }
  MostrarMotivo(): boolean {
    return !this.registrarEstado || (this.registrarEstado && this.estadoDependienteFecha);
  }
}
